import ImageWithFallback from './ImageWithFallback';

export default ImageWithFallback;
